import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Email",
  "use": "icon-Email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Email\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 176.75 65 176.75l0 670.5 4.118 0 52.688 0L512 847.25l390.194 0 52.688 0L959 847.25l0-670.5L512 176.75zM883.395 206.55 512 553.192 140.606 206.55 883.395 206.55zM883.395 817.449 140.606 817.449l283.595-264.693-21.841-20.371L96.925 817.449 94.8 817.449 94.8 206.55l2.125 0L512 593.949 927.076 206.55l2.124 0 0 610.899-2.124 0L621.641 532.385 599.8 552.756 883.395 817.449z\" p-id=\"2854\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Email.svg
// module id = 4NeG
// module chunks = 118